import { NgModule } from "@angular/core";
import { AuthorizationModule } from "./authorization/authorization.module";
import { NotifyModule } from "../notify/notify.module";
import { MsalLoginComponent } from "./msal-login/msal-login.component";
import { UserRepository } from "../user/user.repository";

@NgModule({
  imports: [NotifyModule, MsalLoginComponent],
  exports: [AuthorizationModule, MsalLoginComponent],
  providers: [UserRepository],
})
export class SecurityModule {}
